<template>
  <v-container>
    <ContentHeader
      header-icon="mdi-format-list-group"
      header-title="Bulk Grouping File"
      back-navigation
      back-navigation-href="/admin"
      back-navigation-text="To Old Admin"
    >
    </ContentHeader>
    <pt-sheet title="Upload bulk grouping file" class="main-content">
      <template v-if="success">
        <div class="text-center employees-upload-success">
          <v-icon style="margin-bottom: 56px">$employeeUploadSuccess</v-icon>
          <p>
            The file has been uploaded. There is no way to view results right
            now, so contact a developer.
          </p>
          <yellow-button @click="reset">Reset</yellow-button>
        </div>
      </template>
      <template v-else>
        <div class="d-flex justify-center">
          <file-upload-dnd
            class="flex-grow-1"
            :accepted-files="{
              CSV: 'text/csv'
            }"
            :dropzone-options="dropzoneOptions"
            title="Upload Bulk Grouping File"
            @input="fileId = $event"
          >
          </file-upload-dnd>
        </div>

        <div class="text-right mt-8">
          <v-btn
            class="mb-4"
            depressed
            color="primary"
            @click="uploadFile()"
            :block="$vuetify.breakpoint.xsOnly"
            :disabled="!fileId"
          >
            Upload File
          </v-btn>
        </div>
      </template>
    </pt-sheet>
  </v-container>
</template>

<script>
import FileUploadDnd from "@/components/FileUploadDnd";
import { post } from "@/services/request";
import PtSheet from "@/components/PtSheet.vue";
import hasNotifications from "@/mixins/has-notifications";
import hasCurrentUser from "@/mixins/has-current-user";
import { groupingUploadAPI } from "@/services/api";
import YellowButton from "@/components/providertrust/buttons/SmallYellowButton";
import ContentHeader from "@/views/ContentHeader.vue";

const dropzoneOptions = {
  url: "/services/files",
  headers: {
    "user-type": "admin",
    "directory-name": "covg-grouping"
  }
};

export default {
  name: "AdminGrouping",

  mixins: [hasCurrentUser, hasNotifications],
  components: {
    ContentHeader,
    PtSheet,
    FileUploadDnd,
    YellowButton
  },

  data() {
    return {
      fileId: null,
      dropzoneOptions,
      success: false
    };
  },
  created() {},
  computed: {},
  methods: {
    reset() {
      this.fileId = null;
      this.success = false;
    },
    uploadFile() {
      const fileId = this.fileId;

      post(groupingUploadAPI, {
        fileId
      }).then(
        () => {
          console.log("Grouping file submit successful, fileId: ", fileId);

          this.reset();
          this.success = true;
        },
        error => {
          console.error("Grouping file submit failed, fileId: ", fileId);

          if (!error.response || error.response.status === 500) {
            this.showMessage({
              mode: "error",
              text: "Unknown error. Please try again later"
            });
            return;
          } else {
            this.showMessage({
              mode: "error",
              text:
                "Invalid file. Please upload a file with three columns in this order: cov id, old group id, new group id"
            });
            return;
          }
        }
      );
    }
  }
};
</script>
